

export default function () {
  const widgetName = 'cardWidgetTwo';
  const widgetOpts = cardWidgetTwoOpts;

  return saffire.widgets.cardWidget($(`#${widgetName}`), {
    currentWidgetModuleItemID: widgetOpts.currentWidgetModuleItemID,
    buyNowButton: {
      visible: false,
      text: 'BUY NOW'
    },
    cardWidgetLoaded: function (data, owl, hasData) {
      $('#cardWidgetTwo .card-widget-item').each(function (x) {

        $(this).addClass(`wheel-${x + 1}`);
        $(this).append('<div class="overlay"></div>');
        $(this).append('<div class="border"></div>');
        $(this).removeAttr('target');
        $(this).find('.buttonwrap').remove();

        $(this).attr({
          "data-aos": "fade-up",
          "data-aos-easing": "linear",
          "data-aos-duration": "300",
          "data-aos-delay": (x + 1) * 250,
          "data-aos-once": "true",
          "data-aos-offset": (x == 1 || x == 3 ? "300" : "200"),
        })

        if ($(this).hasClass('void-link')) {
          $(this).removeAttr('href');
          $(this).css('cursor', 'default');
        } else {
          $(this).addClass('active');
        } 

      });
    },
    itemsPerPanel: 1,
    hasImages: true,
    lazyLoadImages: false,
    imageIsBackground: true,
    link: ['all'], // [], ['all'], ['image', 'title', 'description']
    maxItemsVisible: 5,
    moreButton: {
      visible: false,
      text: 'MORE'
    },
    scriptPath: widgetOpts.scriptPath,
    showDescription: false,
    textOverImage: false
  });

}